import Popover from "@hydrologiq/shared/chakra/Popover"
import AssetCreationForm from "./AssetCreationForm"
import * as gqlTypes from "@hydrologiq/gql-experience/graphql"
import { useState } from "react"
interface AssetCreatePopoverProps {
  onSuccess: (asset: gqlTypes.Asset) => void
}

function AssetCreatePopover({ onSuccess }: AssetCreatePopoverProps) {
  const [open, setOpen] = useState(false)
  return (
    <Popover
      placement="right-end"
      actionType="create"
      actionVariant="primary"
      actionContent={{ label: "Create", description: "Create a new asset" }}
      open={open}
      onOpenChange={setOpen}
    >
      <AssetCreationForm
        onSuccess={(asset: gqlTypes.Asset) => {
          onSuccess(asset)
          setOpen(false)
        }}
      />
    </Popover>
  )
}

export default AssetCreatePopover
